import noop from 'lodash-es/noop';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import variables from '../variables';

const variants = {
  blue: {
    color: 'var(--whiteColor)',
    hoverColor: 'var(--whiteColor)',
    backgroundColor: 'var(--primaryColor)',
    hoverBackgroundColor: variables.colors.highlightBlue,
    borderColor: 'var(--whiteColor)',
    hoverBorderColor: 'var(--whiteColor)',
  },
  blueNoBorder: {
    color: variables.colors.white,
    hoverColor: variables.colors.white,
    backgroundColor: 'var(--primaryColor)',
    hoverBackgroundColor: variables.colors.highlightBlue,
    borderColor: 'var(--borderColorLight)',
    hoverBorderColor: 'var(--primaryColor)',
  },
  white: {
    color: 'var(--primaryColor)',
    hoverColor: variables.colors.highlightBlue,
    backgroundColor: 'transparent',
    hoverBackgroundColor: 'var(--transparentBackground-90)',
    borderColor: 'var(--primaryColor)',
    hoverBorderColor: variables.colors.highlightBlue,
  },
  whiteNoBorder: {
    color: 'var(--primaryColor)',
    hoverColor: variables.colors.highlightBlue,
    backgroundColor: 'var(--whiteColor)',
    hoverBackgroundColor: 'var(--whiteColor)',
    borderColor: 'var(--whiteColor)',
    hoverBorderColor: 'var(--whiteColor)',
  },

  transparent: {
    color: 'var(--textColor)',
    hoverColor: 'var(--textColor)',
    backgroundColor: 'var(--transparentBackground-10)',
    hoverBackgroundColor: 'var(--transparentBackground-20)',
    borderColor: 'transparent',
    hoverBorderColor: 'var(--transparentBackground-20)',
  },
};

const ControlButton = styled.button.attrs(props => ({
  onClick: props.disabled ? noop : props.onClick,
}))`
  display: block;
  min-width: 36px;
  max-width: 100%;
  height: 33px;
  line-height: 31px;
  color: ${props => variants[props.variant].color} !important;
  background-color: ${props =>
    variants[props.variant].backgroundColor} !important;
  border: ${props =>
    `1px solid ${variants[props.variant].borderColor}`} !important;
  font-family: Roboto, sans-serif;
  font-size: 15px;
  font-weight: 600;
  outline: none;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease-out;
  padding: 0 10px;
  border-radius: 5px;

  &:hover {
    color: ${props => variants[props.variant].hoverColor} !important;
    background-color: ${props =>
      variants[props.variant].hoverBackgroundColor} !important;
    border: ${props =>
      `1px solid ${variants[props.variant].hoverBorderColor}`} !important;
  }

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  ${props =>
    props.showFocus &&
    css`
      &:focus {
        box-shadow: 0 0 0 2px var(--primaryColor);
      }
    `}
`;
ControlButton.propTypes = {
  variant: PropTypes.oneOf([
    'blue',
    'white',
    'blueNoBorder',
    'whiteNoBorder',
    'transparent',
  ]).isRequired,
  disabled: PropTypes.bool,
  showFocus: PropTypes.bool,
  onClick: PropTypes.func,
  style: PropTypes.objectOf(PropTypes.any),
};
ControlButton.defaultProps = {
  style: {},
  disabled: false,
  showFocus: true,
  onClick: noop,
};
export default ControlButton;

export const ControlButtonGroup = styled.div`
  display: flex;

  &:only-child {
    margin-left: auto;
  }

  ${ControlButton}:not(:first-child) {
    margin-left: 15px;
  }
`;

export const ControlButtonGroupFull = styled.div`
  display: flex;

  ${ControlButton} {
    flex: 1;

    &:last-child {
      flex: 4;
    }

    &:not(:last-child) {
      margin-right: 5px;
    }
`;
ControlButtonGroup.propTypes = {
  children: PropTypes.node.isRequired,
};
